import type { Locale } from '../Entities/Locale/Locale.entity';
import type { SortTypes } from '../Entities/Search/Sort.entity';

const SORT_OPTIONS_UK = [
  'relevance-desc',
  'distance-asc',
  'year-asc',
  'year-desc',
  'price-asc',
  'price-desc',
  'mileage-asc',
  'mileage-desc',
  'date-active-desc',
];

const SORT_OPTIONS_UK_EXPERIMENT = [
  'i15_uk_elo',
  'distance-asc',
  'year-asc',
  'year-desc',
  'price-asc',
  'price-desc',
  'mileage-asc',
  'mileage-desc',
  'date-active-desc',
];

const SORT_OPTIONS_FR = [
  'distance-asc',
  'price-asc',
  'price-desc',
  'discount-desc',
  'mileage-asc',
  'mileage-desc',
  'date-created-desc',
];

const SORT_ORDER_EXPERIMENT_CONTROL = {
  de: 'relevance-desc',
  fr: 'i15_fr_elo',
  uk: 'relevance-desc',
};

const SORT_ORDER_EXPERIMENT_VARIANT = {
  de: 'i15_de_elo',
  fr: 'i15_fr_elo_variant',
  uk: 'i15_uk_elo',
};

const DEFAULT_SORTING: { [key in Locale]?: SortTypes } = {
  uk: 'relevance-desc',
};

const DEFAULT_SORTING_EXPERIMENT: { [key in Locale]?: SortTypes } = {
  uk: 'i15_uk_elo',
};

const SORT_KEY = 'sort';

export {
  DEFAULT_SORTING,
  DEFAULT_SORTING_EXPERIMENT,
  SORT_KEY,
  SORT_OPTIONS_FR,
  SORT_OPTIONS_UK,
  SORT_OPTIONS_UK_EXPERIMENT,
  SORT_ORDER_EXPERIMENT_CONTROL,
  SORT_ORDER_EXPERIMENT_VARIANT,
};
